// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__bG-c0","wrapper":"style_wrapper__VNOYv","container":"style_container__wpdzw"};